import React from 'react'
import gql from 'graphql-tag'
import { ReelFeedback_video } from 'routes/video/components/ReelFeedback.fragments'
import { Mutation } from 'react-apollo'

export const SUBMIT_REEL_FEEDBACK = gql`
  mutation SubmitReelFeedbackMutation($input: SubmitReelFeedbackInput!) {
    submitReelFeedback(input: $input) {
      feedback {
        positive
        text
        videoId
      }
    }
  }
`

const SubmitReelFeedback = ({ videoId, children }) => (
  <Mutation
    mutation={SUBMIT_REEL_FEEDBACK}
    update={(
      store,
      {
        data: {
          submitReelFeedback: { feedback }
        }
      }
    ) => {
      // TODO this is a hacky workaround to prevent crashing if text feedback
      // was not submitted.
      feedback.text = feedback.text || ''
      const data = store.readFragment({
        id: videoId,
        fragment: ReelFeedback_video
      })
      store.writeFragment({
        id: videoId,
        fragment: ReelFeedback_video,
        data: { ...data, feedback }
      })
    }}
  >
    {mutate =>
      children((positive, text) =>
        mutate({
          variables: { input: { videoId, positive, text } },
          optimisticResponse: {
            submitReelFeedback: {
              __typename: 'SubmitReelFeedbackPayload',
              feedback: { __typename: 'ReelFeedback', videoId, positive, text }
            }
          }
        })
      )
    }
  </Mutation>
)

export default SubmitReelFeedback



// WEBPACK FOOTER //
// ./src/mutations/SubmitReelFeedback.js